// import { useState, useEffect } from 'react'
import clsx from 'clsx'
import classes from '../Card.module.scss'

import { CardAudio } from '../CardAudio';

export function CardTextAudio({ cardData, isPressed, autoplay }) {
  return (
    <>
      <CardAudio cardData={cardData} isPressed={isPressed} autoplay={autoplay}/>
      <div className={clsx(classes.card__caption)}>
        {cardData.text}
      </div>
    </>
  )
}

// CardTextAudio.propTypes = {
//   text: PropTypes.string.isRequired,
//   audioSrc: PropTypes.string.isRequired
// }